import React, {Component} from 'react';
import styles from './Radio.less';

export default class Radio extends Component {
	render() {
		const {children, className, refNode, hint, ...props} = this.props;
		const {
			radio: radioClass,
			radio__inputBox: inputBoxClass,
			radio__contentBox: contentBoxClass,
			radio__input: inputClass,
			radio__hint: hintClass
		} = styles;
		const classes = [radioClass];

		if (className) {
			classes.push(className);
		}

		return (
			<label className={classes.join(' ')}>
				<span className={inputBoxClass}>
					<input type="radio" className={inputClass} ref={refNode} {...props} />
				</span>
				{(children || hint) && (
					<span className={contentBoxClass}>
						{children}
						{hint && (
							<span className={hintClass}>{hint}</span>
						)}
					</span>
				)}
			</label>
		);
	}
}